import { asyncAction } from 'lib/actions';

export const analyticsListFetchAction = asyncAction('analyticsListPage/LIST_FETCH');
export const analyticsListAppendPageAction = asyncAction('analyticsListPage/LIST_APPEND_PAGE');
export const downloadRtvPdfAction = asyncAction('rtvValueListPage/DOWNLOAD_PDF');
